import { Routes } from '@angular/router';
import { TwoColumnsRightComponent } from '../upgrade/main.template.directive';
import {
  DashboardTemplatesListComponent,
  DashboardTemplateFormComponent,
  DashboardTemplatesReorderComponent
} from '../upgrade/dashboard-templates.directive';
import { setupGuard } from '@fry/upgrade/setup.guard';
import { authGuard, forceOnlineGuard } from '@fry-it/risr-core';
import { unsavedGuard } from '@fry/upgrade/unsaved.guard';

export const dashboardTemplatesRoutes: Routes = [
  {
    path: 'dashboard-templates',
    component: TwoColumnsRightComponent,
    canActivate: [setupGuard, authGuard],
    data: {
      permission: 'dashboardTemplates.view'
    },
    children: [
      {
        path: '',
        component: DashboardTemplatesListComponent,
        data: {
          state: 'epf.dashboard-templates.index'
        },
        canActivate: [forceOnlineGuard]
      },
      {
        path: 'new',
        component: DashboardTemplateFormComponent,
        canActivate: [authGuard, forceOnlineGuard],
        canDeactivate: [unsavedGuard],
        data: {
          permission: 'dashboardTemplates.edit',
          state: 'epf.dashboard-templates.new'
        }
      },
      {
        path: 'edit/:id',
        component: DashboardTemplateFormComponent,
        canActivate: [authGuard, forceOnlineGuard],
        canDeactivate: [unsavedGuard],
        data: {
          permission: 'dashboardTemplates.edit',
          state: 'epf.dashboard-templates.edit'
        }
      },
      {
        path: 'reorder',
        component: DashboardTemplatesReorderComponent,
        canActivate: [authGuard, forceOnlineGuard],
        data: {
          permission: 'dashboardTemplates.edit',
          state: 'epf.dashboard-templates.reorder'
        }
      }
    ]
  }
];
